import type { JSX } from "react";

import { useTranslation } from "react-i18next";

import type { IStatusError } from "@/shop/types/errors";

import { getExceptionMessage } from "../../../../utils/exceptions";

interface AttachmentErrorNoticeProps {
  header?: string;
  message?: string;
  error?: IStatusError;
}
export default function AttachmentErrorNotice({ header, message, error }: AttachmentErrorNoticeProps): JSX.Element {
  const { t } = useTranslation();

  return (
    <>
      {error ? (
        <div>
          <h5>{getExceptionMessage(error.statusCode!, t)}</h5>
          <p>{message && t(error.message)}</p>
        </div>
      ) : (
        <div>
          <h5>{header && t(header)}</h5>
          <p>{message && t(message)}</p>
        </div>
      )}
    </>
  );
}
